import { render, staticRenderFns } from "./EditCustomerAccountForm.vue?vue&type=template&id=2a80141e&scoped=true&"
import script from "./EditCustomerAccountForm.vue?vue&type=script&lang=js&"
export * from "./EditCustomerAccountForm.vue?vue&type=script&lang=js&"
import style0 from "./EditCustomerAccountForm.vue?vue&type=style&index=0&id=2a80141e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a80141e",
  null
  
)

export default component.exports